import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import Department from './Department';

export default function Appointments(props) {
    const [appointments, setAppointment] = useState([]);
    const [department, setDepartment] = useState();
    const [show, setShow] = useState(false);
    const departmentRef = useRef();

    useEffect(() => {
        axios.post('http://localhost:5000/Appointments/UserAppointments', { id: props.id })
            .then((response) => {
                setAppointment(response.data);

            })
            .catch((error) => {
                console.log(error);
            })
    })

    useEffect(() => {
        axios.post('http://localhost:5000/Appointments/UserAppointments', { id: props.id })
            .then((response) => {
                setAppointment(response.data);

            })
            .catch((error) => {
                console.log(error);
            })
    }, [appointments])

    const handleClick = props => { 
        departmentRef.current = props.department;
        if (props.show === true) { 
            setShow(true);
        } else { 
            setShow(false);
        }
    }

    return (
        <React.Fragment>
            <div className="Appointments">
                <p>You have {appointments.length} coming up.</p>

                {

                    [...Array((appointments.length))].map((e, i) =>

                        <>

                            <ul>
                                <li><b>Department</b>: <a href="#" onClick={() => handleClick({ department: appointments[i].department, show: true})}>{appointments[i].department}</a></li>
                                <li><b>Doctor</b>: {appointments[i].doctor}</li>
                                <li><b>Day</b>: {dayjs(appointments[i].from).format('dddd MMMM D')}</li>
                                <li><b>From</b>:{dayjs(appointments[i].from).format('h:mm A')}</li>
                                <li><b>To</b>: {dayjs(appointments[i].to).format('h:mm A')}</li>
                            </ul>

                            
                        </>
                    )
                }

                
            </div>
            {department === null ? props.department : (
            <Department name={departmentRef.current} show={show} onClose={() => setShow(false)} />
            )};
        </React.Fragment>
    )
}